var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCurrencyRub = function SvgIconCurrencyRub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.25 2.75a1 1 0 0 0-1 1v8.75h-2a1 1 0 1 0 0 2h2v1.75h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h4.25a1 1 0 1 0 0-2H9.25V14.5h4.625a5.876 5.876 0 0 0 0-11.75zm5.625 9.75H9.25V4.75h4.625a3.875 3.875 0 0 1 0 7.75",
    clipRule: "evenodd"
  })));
};
export default SvgIconCurrencyRub;